import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "./api";

const getTokenFromLocalStorage = () => {
  return localStorage.getItem("token");
};

export const couponApi = createApi({
  reducerPath: "couponApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/coupons`,
    prepareHeaders: (headers) => {
      const token = getTokenFromLocalStorage();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Coupon"],
  endpoints: (builder) => ({
    checkCoupon: builder.mutation({
      query: (data) => ({
        url: "/checkValidCoupon",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Coupon"],
    }),
  }),
});
export const { useCheckCouponMutation } = couponApi;
